<template>
  <div class="flex-1 mt-1 bg-gray-100 px-4 pt-12 shadow-lg items-center">
    <div class="bg-white w-full rounded-lg shadow">

      <!--  -->
      <div class="h-20 py-3 flex items-center border-gray-200 p-6 mt-2">
        <div class="flex">
          <button :class="$colors.primary" class="rounded-full flex justify-center items-center w-8 h-8 mr-3" @click="RouterBack()">
            <i class="material-icons">chevron_left</i>
          </button>
          <div v-if="!formData._id" class="text-2xl font-bold text-green-500">
            New Ticket
          </div>
          <div v-else class="text-2xl font-bold text-green-500">Edit ticket</div>
        </div>
      </div>
      <!--  -->

      <!--  -->
      <div class="">
        <!--  -->
        <div class="bg-white rounded-lg p-6 pt-2">
          <!--  -->
          <div class="grid lg:grid-cols-2 gap-6">
            <!-- Subject -->
            <div class="border hover:border-green-400 focus-within:border-green-500  focus-within:text-green-500 transition-all duration-500 relative rounded p-1">
              <!--  -->
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <p>
                  <label for="name" class="bg-white text-gray-700 px-1">
                    Subject <span :class="$colors.required">*</span>
                  </label>
                </p>
              </div>
              <!--  -->

              <!--  -->
              <p>
                <input id="name" autocomplete="false" tabindex="0" type="text" v-model="formData.subject" class="py-2 text-xs px-2 outline-none block h-full w-full"/>
              </p>
              <!--  -->
            </div>
            <!-- Subject -->

            <!-- Priority -->
            <div class="border hover:border-green-500   w-full focus-within:border-green-500  focus-within:text-green-500 transition-all duration-500 relative rounded p-1">
              <!--  -->
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <p>
                  <label for="customerPhone" class="bg-white text-gray-700 px-1">
                    Priority <span :class="$colors.required">*</span>
                  </label>
                </p>
              </div>
              <!--  -->

              <!--  -->
              <p>
                <v-select v-model="formData.priority" :options="priorityOptions" label="name">
                  <template slot="option" slot-scope="option">
                    <span class="" >{{ option.name }}</span>
                  </template>
                </v-select>
              </p>
              <!--  -->
            </div>
            <!-- Priority -->

            <!-- Department -->
            <div class="border hover:border-green-500   w-full focus-within:border-green-500  focus-within:text-green-500 transition-all duration-500 relative rounded p-1">
              <!--  -->
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <p>
                  <label for="customerPhone" class="bg-white text-gray-700 px-1">
                    Department <span :class="$colors.required">*</span>
                  </label>
                </p>
              </div>
              <!--  -->

              <!--  -->
              <p>
                <v-select v-model="formData.department" :options="departmentOptions" label="name">
                  <template slot="option" slot-scope="option">
                    <span class="">{{ option.name }}</span>
                  </template>
                </v-select>
              </p>
              <!--  -->
            </div>
            <!-- Department -->

            <!-- Warehouse -->
            <div class="border hover:border-green-500   w-full focus-within:border-green-500  focus-within:text-green-500 transition-all duration-500 relative rounded p-1">
              <!--  -->
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <p>
                  <label for="customerPhone" class="bg-white text-gray-700 px-1">
                    Country (Warehouse) <span :class="$colors.required">*</span>
                  </label>
                </p>
              </div>
              <!--  -->

              <!--  -->
              <p>
                <v-select @input="setSelectedCountry" v-model="formData.country" :options="warehouseOptions" label="name">
                  <template slot="option" slot-scope="option">
                    <img class="flag-img" :src="$f.getCountryCode(option.code)" />
                    {{ option.name }}
                  </template>
                </v-select>
              </p>
              <!--  -->
            </div>
            <!-- Warehouse -->

            <!-- Seller -->
            <div v-if="currentUser.type != 'Seller'" class="border hover:border-green-500   w-full focus-within:border-green-500  focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
              <!--  -->
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <p>
                  <label for="customerPhone" class="bg-white text-gray-700 px-1">
                    Seller <span :class="$colors.required">*</span>
                  </label>
                </p>
              </div>
              <!--  -->

              <!--  -->
              <p>
                <v-select @search="getUsersDebounce($event, 'shipsen')" v-model="formData.seller" :options="sellerOptions" label="fullName">
                  <template slot="option" slot-scope="option">
                    {{ option.fullName }}
                  </template>
                </v-select>
              </p>
              <!--  -->
            </div>
            <!-- Seller -->

            <!-- Status -->
            <div v-if="$route.params.id" class="border hover:border-green-500   w-full focus-within:border-green-500  focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
              <!--  -->
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <p>
                  <label for="status" class="bg-white text-gray-700 px-1">
                    Status <span :class="$colors.required">*</span>
                  </label>
                </p>
              </div>
              <!--  -->

              <!--  -->
              <p>
                <v-select v-model="formData.status" :options="statusOptions" label="name" :disabled="formData.status.value == 'close' ? true : false">
                  <template slot="option" slot-scope="option">
                    {{ option.name }}
                  </template>
                </v-select>
              </p>
              <!--  -->
            </div>
            <!-- Status -->
          </div>

          <div class="mt-6 border hover:border-green-400 focus-within:border-green-500  focus-within:text-green-500 transition-all duration-500 relative rounded p-1">
            <!--  -->
            <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
              <p>
                <label for="Picture" class="bg-white text-gray-700 px-1">Picture</label>
              </p>
            </div>
            <!--  -->
            <div class="flex w-full mt-10 mb-10  items-center justify-center bg-grey-lighter">
              <label class="w-64 flex flex-col items-center px-4 py-6 bg-white text-blue rounded-lg shadow-lg tracking-wide uppercase border border-blue cursor-pointer hover:bg-blue hover:text-green-900">
                  <svg  v-if="formData.picture==''" class="w-8 h-8" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                      <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
                  </svg>
                  <img v-if="formData.picture!=''" :src="formData.picture" alt="" />
                  <span v-if="formData.picture==''" class="mt-2 text-base leading-normal">Select a image</span>
                  <input type='file' @change="handleImage($event)" class="hidden" accept="image/*"   />
              </label>
            </div>
            <!--  -->
          </div>
          <!--  -->

          <!-- Description -->
          <div class="mt-6 border hover:border-green-400 focus-within:border-green-500  focus-within:text-green-500 transition-all duration-500 relative rounded p-1">
            <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
              <p>
                <label for="description" class="bg-white text-gray-700 px-1">
                  Description
                </label>
              </p>
            </div>
            <p>
              <textarea id="description" autocomplete="false" tabindex="0" v-model="formData.description" class="py-2 text-xs px-2 outline-none block h-full w-full"></textarea>
            </p>
          </div>
          <!-- Description -->
        </div>
        <!--  -->

        <!--  -->
        <div class="pt-3 flex justify-center p-10 has-tooltip">
          <button class="rounded focus:outline-none outline-none text-gray-100 px-3 w-1/6 py-2 bg-green-500 hover:shadow-inner hover:bg-green-700 transition-all duration-300 relative loidingconfirm" :class="loading ? 'noselect' : ''" @click="save" :disabled="loading">
            <loading :active.sync="loading" :is-full-page="fullPage"></loading>
            Save
          </button>
        </div>
        <!--  -->
      </div>
      <!--  -->
    </div>
    <!--  -->
  </div>
</template>

<script>
export default {
  props: {
    currentUser: { type: Object }
  },
  data() {
    return {
      formData: {
        subject: "",
        priority: { name: 'Low', value: 'low' },
        department: { name: 'Call Center', value: 'callcenter' },
        country: null,
        seller: null,
        status: { name: 'Open', value: 'open' },
        description: "",
        chat: [],
        picture: ""
      },
      priorityOptions: [
        { name: 'Low', value: 'low' },
        { name: 'Medium', value: 'medium' },
        { name: 'High', value: 'high' },
      ],
      statusOptions: [
        { name: 'Open', value: 'open' },
        { name: 'Close', value: 'close' },
      ],
      departmentOptions: [
        { name: 'Call Center', value: 'callcenter' },
        { name: 'Stock Manager', value: 'stockmanager' },
        { name: 'Facturation', value: 'facturation' },
      ],
      options: this.$countries,
      warehouseOptions: [],
      sellerOptions: [],
      loading: false,
      fullPage: false,
    };
  },
  async mounted() {
    await this.getWarehouses();
      await this.getSellers();
      await this.dataToEdit();
  },
  methods: {
    RouterBack: function() {
      this.$router.back();
    },
    async getWarehouses() {
      const filter = { limit:10 };
      const res = await this.$server.search("warehouses", filter);
      if (res.content.results) {
          let data = res.content.results;
          for(let i in data){
            this.warehouseOptions.push({
              name:this.$f.getCountryNameByCode(this.options,data[i].country),
              code:data[i].country
            })
          }
      } else this.warehouseOptions = [];
    },
    handleImage(e){
        const selectImage=e.target.files[0];
        if(selectImage) this.createBase64Image(selectImage);
    },
    createBase64Image(fileObjet){
      const reader=new FileReader();
      reader.readAsDataURL(fileObjet);
      reader.onload= ()  =>{
        this.formData.picture= reader.result;
      };
    },
    async setSelectedCountry(country) {
      if (country) {
        this.formData.seller = null;
        if(this.currentUser.type != "Seller") {
          await this.getSellers();
        }else {
          this.sellerOptions = [];
          this.formData.seller = this.currentUser;
        }
      } else {
        this.formData.country = null;
      } 
    },
    async getSellers() {
      if (this.formData.country) {
        const res = await this.$server.search("users", {
          type: "Seller",
          countries: this.formData.country.code,
        });

        if (res && res.content.results) {
          this.sellerOptions = res.content.results;
        } else {
          this.sellerOptions = [];
        }
      }
    },
    getUsersDebounce: _.debounce(async function (name) {
      await this.$store.dispatch('wharhouse/searchUser',
      { type: "Seller", search: name }).then((res) => {
        this.sellerOptions = res
      })
    }, 500),
    async dataToEdit() {
      if (this.$route.params.id) {
        const editData = await this.$server.get("tickets", {
            id: this.$route.params.id,
        });

        if (editData.error) {
            console.error("Error getting ticket:", editData.error);
        } else {
            this.formData = editData.result;
            this.formData.country= this.$f.getCountryNameByCode(this.options, editData.result.country);
            if(this.currentUser.type != "Seller") {
              await this.getSellers();
            }
        }
      }
    },
    async save() {
      if (!this.checkData() && this.checkSize()) {
        alert("You must fill all the fields et image ne doit pas dépasser 500 !", "warning");
        return;
      }

      this.loading = true;
      let data;

      try {
        if (this.formData._id) {
          if(!this.checkSize()){
            alert(`la taille de image doit pas dépasser 500 ko !! `, "warning");
            return false;
          }

          this.formData.country = this.formData.country.code;
          data = await this.$server.update("tickets", this.formData);
          await this.dataToEdit();
        } else {
          this.formData.country= this.formData.country.code;
          data = await this.$server.create("tickets", this.formData);

          this.formData = {
            subject: "",
            priority: { name: 'Low', value: 'low' },
            department: { name: 'Call Center', value: 'callcenter' },
            country: null,
            seller: null,
            status: { name: 'Open', value: 'open' },
            description: "",
            chat: [],
            picture: ""
          };
        }

        if (data && data._id) {
          alert(this.formData._id ? "Ticket updated" : "Ticket created", "success");
        } else {
          alert(data, "warning");
        }

      } catch (error) {
        console.error("Error saving ticket:", error);
        alert("An error occurred while saving the ticket", "error");
      } finally {
        this.loading = false;
      }
    },
    checkData() {
      return (
        this.formData.subject.length > 0 &&
        this.formData.priority &&
        this.formData.department &&
        this.formData.country &&
        this.formData.seller &&
        this.formData.status &&
        this.formData.description.length > 0
      );
    },
    checkSize(){
      let base64Length = this.formData.picture.length - (this.formData.picture.indexOf(',') + 1);
      let padding = (this.formData.picture.charAt(this.formData.picture.length - 2) === '=') ? 2 : ((this.formData.picture.charAt(this.formData.picture.length - 1) === '=') ? 1 : 0);
      let fileSize = base64Length * 0.75 - padding
      let sizeImage = this.niceBytes(fileSize);
      let typeSize=sizeImage.split(' ')[1];
      if(typeSize==="bytes" || typeSize==="KB") {
        if(sizeImage.split(' ')[0]<=500)  return true;
        else return false;
      } else return false;
    },
    niceBytes(x){
      const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      let l = 0, n = parseInt(x, 10) || 0;
      while(n >= 1024 && ++l) {
          n = n/1024;
      }
      return(n.toFixed(n < 10 && l > 0 ? 1 : 0) + ' ' + units[l]);
    },
  }
};
</script>